import styled, { css } from 'styled-components';

const wideBreakpoint = '1350px';

export const Backdrop = styled.div`
  ${({ theme: { spacing } }) => css`
    position: fixed;
    top: ${spacing.sm};
    left: 50%;
    z-index: 1010;
    transform: translateX(-50%);
    transition: top 200ms;

    @media screen and (min-width: 768px) {
      top: ${spacing.lg};
    }
  `}
`;

export const Banner = styled.div`
  ${({ theme: { spacing } }) => css`
    background: white;
    padding: ${spacing.p5} ${spacing.p7};
    display: flex;
    flex-direction: column;
    gap: ${spacing.p3};
    align-items: center;
    max-width: 700px;
    width: 100%;
    width: fit-content;
    box-shadow: 0px 4px 4px 0px rgba(0, 0, 0, 0.25);
    border-radius: ${spacing.p2};

    @media screen and (min-width: ${wideBreakpoint}) {
      flex-direction: row;
      gap: ${spacing.p5};
    }
  `}
`;

export const Actions = styled.div`
  ${({ theme: { spacing } }) => css`
    display: flex;
    gap: ${spacing.p3};
    align-items: center;
  `}

  button,
  a {
    white-space: nowrap;
  }
`;

export const Description = styled.div`
  ${({ theme: { color, spacing } }) => css`
    color: ${color.midnight10};
    text-align: center;

    @media screen and (min-width: ${wideBreakpoint}) {
      text-align: left;
    }
  `}
`;
